import { QUERY, CHANGE_QUERY } from "../action/action-types";

export default function query(state = '', action){
    switch(action.type){
        case QUERY:
            return state = action.payload
        case CHANGE_QUERY:
            return state = action.payload
        default:
            return state
    }
}